<template>
  <div>
    <v-tooltip v-if="position == 'top'" top>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <p class="font-weight-medium mb-0" :class="{ 'grey-text' : !isLink, 'is-link' : isLink }">
            {{ text }}
            <span v-if="text.length > 0">&nbsp;</span>
            <v-icon @click="iconClickFunction()" :size="iconSize" aria-hidden="false">
              {{iconName}}
            </v-icon>
            <span v-show="text.length > maxTextLength">...</span>
          </p>
        </span>
      </template>
      <span>{{ hoverText }}</span>
    </v-tooltip>
    <v-tooltip v-if="position == 'bottom'" bottom>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <p class="font-weight-medium mb-0" :class="{ 'grey-text' : !isLink, 'is-link' : isLink }">
            {{ text }}
            <span v-if="text.length > 0">&nbsp;</span>
            <v-icon @click="iconClickFunction()" :size="iconSize" aria-hidden="false">
              {{iconName}}
            </v-icon>
            <span v-show="text.length > maxTextLength">...</span>
          </p>
        </span>
      </template>
      <span>{{ hoverText }}</span>
    </v-tooltip>
    <v-tooltip v-if="position == 'left'" left>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <p class="font-weight-medium mb-0" :class="{ 'grey-text' : !isLink, 'is-link' : isLink }">
            {{ text }}
            <span v-if="text.length > 0">&nbsp;</span>
            <v-icon @click="iconClickFunction()" :size="iconSize" aria-hidden="false">
              {{iconName}}
            </v-icon>
            <span v-show="text.length > maxTextLength">...</span>
          </p>
        </span>
      </template>
      <span>{{ hoverText }}</span>
    </v-tooltip>
    <v-tooltip v-if="position == 'right'" right>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <p class="font-weight-medium mb-0" :class="{ 'grey-text' : !isLink, 'is-link' : isLink }">
            {{ text }}
            <span v-if="text.length > 0">&nbsp;</span>
            <v-icon @click="iconClickFunction()" :size="iconSize" aria-hidden="false">
              {{iconName}}
            </v-icon>
            <span v-show="text.length > maxTextLength">...</span>
          </p>
        </span>
      </template>
      <span>{{ hoverText }}</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
    textFontSize: Number,
    hoverText: String,
    position: String,
    maxTextLength: Number,
    iconName: String,
    iconSize: String,
    iconClickFunction: Function,
    isLink: String
  },
};
</script>